"use client";

import { truncateAddress } from "logic/utils";
import { DramaIcon, XIcon } from "lucide-react";

import { useDevtools } from "./DevtoolsProvider";

export function ImpersonatorBanner() {
  const { impersonatedAddress, setImpersonatedAddress } = useDevtools();

  if (!impersonatedAddress) return null;

  return (
    <>
      <div className="fixed inset-0 pointer-events-none z-[9999] border-4 border-red-900/80" />

      <div className="fixed top-1 left-1/2 -translate-x-1/2 z-[10000] flex items-center gap-2 px-3 py-px bg-red-900/80 text-white text-xs rounded-b-md">
        <DramaIcon className="size-3.5" />
        <span className="font-mono">{truncateAddress(impersonatedAddress)}</span>
        <button
          type="button"
          onClick={() => setImpersonatedAddress(undefined)}
          className="ml-1 hover:text-red-300 transition-colors"
        >
          <XIcon className="size-3.5" />
        </button>
      </div>
    </>
  );
}
